export default class NewsletterSignUp {

	constructor (context) {
		this.context = context;

		this.form = document.getElementById('js-global-newsletter-form');
		this.emailElement = document.getElementById('js-global-newsletter-email');
		this.messagesElem = document.getElementById('js-global-newsletter-messages');

		this.bindEvents();
	}

	bindEvents () {

		if (this.form) {
			this.form.addEventListener('submit', (e) => this.submit(e));
		}

	}

	async submit (e) {
		e.preventDefault();

		if (this.form.getAttribute('status') === 'submitting') {
			return;
		}

		this.form.setAttribute('status', 'submitting');
		this.toggleDisabled(true);

		const request = await fetch(`${this.context.Japi_Url}_cachebust=${Date.now()}`, {
			body: JSON.stringify({
				email: this.emailElement.value,
				function: 'email_signup',
				source: 'footer'
			}),
			credentials: 'same-origin',
			headers: {
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				Expires: 0,
				Pragma: 'no-cache'
			},
			method: 'POST'
		});

		this.form.setAttribute('status', '');
		this.toggleDisabled(false);

		if (!request.ok) {
			this.addErrorMessage('Network response was not successful. Please try again.');
			return;
		}

		const response = await request.json();

		if (response.success !== 1) {
			this.addErrorMessage(response.message);
			return;
		}

		this.addMessage('Thank you for Enlisting!');
	}

	addMessage (message) {
		if (!this.messagesElem) {
			return;
		}

		/* The class `x-messages--success` is added for backwards compatibility for 3rd party JS */
		const messageHTML = `
		<p class="g-messages g-messages--success x-messages--success">
			${message}
		</p>`;

		this.messagesElem.innerHTML = messageHTML;

		this.form.reset();

		setTimeout(() => {
			this.resetMessages();
		}, 5000);
	}

	addErrorMessage (message) {
		if (!this.messagesElem) {
			return;
		}

		const messageHTML = `
		<p class="g-messages g-messages--error">
			${message}
		</p>`;

		this.messagesElem.innerHTML = messageHTML;
	}

	resetMessages () {
		if (!this.messagesElem) {
			return;
		}

		this.messagesElem.innerHTML = '';
	}

	toggleDisabled (disabled) {
		const buttons = this.form.querySelectorAll('[type="submit"]');

		for (const button of buttons) {
			button.disabled = disabled;
		}
	}

}
